import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const bookingService = {
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.booking.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.booking.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
async updateStatus(id,data) {
      const response = await apiClient.put(
        `${endPoints.booking.updateStatus}/${id}/status`,
        JSON.stringify(data), // Enforces wrapping the string in quotes: "WaitingForApproval"
        {
          headers: {
            "Content-Type": "application/json", // Tells ASP.NET to read it as JSON
          },
        },
      );
      return response.data;
  },
  async create(data) {
      const response = await apiClient.post(endPoints.booking.create, data);
      return response.data;
  },
   async update(id,data) {
      const response = await apiClient.put(`${endPoints.booking.update}/${id}`, data);
      return response.data;
  },
  async toggleActivate(id) {
      const response = await apiClient.patch(`${endPoints.provider.toggleActivate}/${id}`);
      return response.data;
  },
  async edit(id) {
      const response = await apiClient.get(`${endPoints.booking.edit}/${id}`);
      return response.data;
  },
  
  async getDetail(id) {
      const response = await apiClient.get(`${endPoints.booking.getDetail}/${id}`);
      return response.data;
  },
  
};
